var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"ctk-nav-bar-mobile-sidebar-button tw-flex tw-border-none tw-appearance-none tw-cursor-pointer",attrs:{"type":"button"}},[_c('div',{class:{ open: _vm.open },attrs:{"id":"icon"}},[_c('span'),_c('span'),_c('span')])])}
var staticRenderFns = []

export { render, staticRenderFns }